(ns practitest.frontend.et.subs
  (:require
    [re-frame.core :as re-frame]))

(re-frame/reg-sub
  :et/initialized?
  (fn [db _]
    (and (:fields (:et-state db))
         (:users (:et-state db))
         (or (nil? (:entity-id (:et-state db)))
             (get-in db [:et-state :entity :id])))))

(re-frame/reg-sub
  :et/loading?
  (fn [db _]
    (or (not @(re-frame/subscribe [:et/initialized?]))
        (seq (:http-calls (:et-state db)))
        (:loading? (:et-state db)))))

(re-frame/reg-sub
  :et/init-complete?
  (fn [db _]
    (:init-complete? (:et-state db))))

(re-frame/reg-sub
  :et/time-management?
  (fn [db _]
    (:time-management (:et-state db))))

(re-frame/reg-sub
  :et/markdown-support?
  (fn [db _]
    (:markdown-support (:et-state db))))

(re-frame/reg-sub
  :et/rtl?
  (fn [db _]
    (:rtl (:et-state db))))

(re-frame/reg-sub
  :et/running-time
  (fn [db _]
    (if-let [[_ running-time _] (:running-time (:et-state db))]
      running-time
      "00:00:00")))

(re-frame/reg-sub
  :et/running?
  (fn [db _]
    (boolean (:running-timer (:et-state db)))))

(re-frame/reg-sub
  :et/fields
  (fn [db _]
    (concat (->> (get-in db [:et-state :fields :system-fields])
                 (remove #(#{"run_status" "run_run_status" "last_run" "tester"} (:uniq-name %))))
            (get-in db [:et-state :fields :custom-fields]))))

(re-frame/reg-sub
  :et/users
  (fn [db _]
    (:users (:et-state db))))

(re-frame/reg-sub
  :et/tester
  (fn [db _]
    (let [tester-id (get-in db [:et-state :entity :tester-id])
          tester (->> @(re-frame/subscribe [:et/users])
                      (filter #(= tester-id (:id %)))
                      first)]
      (:name tester))))

(re-frame/reg-sub
  :et/run-statuses
  (fn [db _]
    (:run-statuses (:et-state db))))

(re-frame/reg-sub
  :et/max-attachment-size
  (fn [db _]
    (:max-attachment-size (:et-state db))))

(re-frame/reg-sub
  :et/title
  (fn [db _]
    (get-in db [:et-state :entity :title])))

(re-frame/reg-sub
  :et/field
  (fn [db [_ field]]
    (get-in db [:et-state :entity :fields field])))

(re-frame/reg-sub
  :et/charter
  (fn [db _]
    (get-in db [:et-state :entity :charter])))

(re-frame/reg-sub
  :et/guide-points
  (fn [db _]
    (get-in db [:et-state :entity :guide-points])))

(re-frame/reg-sub
  :et/preconditions
  (fn [db _]
    (get-in db [:et-state :entity :preconditions])))

(re-frame/reg-sub
  :et/estimate
  (fn [db _]
    (or (get-in db [:et-state :entity :estimate]) "00:00:00")))

(re-frame/reg-sub
  :et/description-filter
  (fn [db _]
    (or (:description-filter (:et-state db)) "")))

(re-frame/reg-sub
  :et/display-filters
  (fn [db _]
    (:display-filters (:et-state db))))

(re-frame/reg-sub
  :et/type-filter
  (fn [db _]
    (or (:type-filter (:et-state db)) "")))

(re-frame/reg-sub
  :et/run-status
  (fn [db _]
    (get-in db [:et-state :entity :run-status])))

(re-frame/reg-sub
  :et/last-run
  (fn [db _]
    (get-in db [:et-state :entity :last-run])))

(re-frame/reg-sub
  :et/created
  (fn [db _]
    (get-in db [:et-state :entity :created])))

(re-frame/reg-sub
  :et/new?
  (fn [db _]
    (nil? (:entity-id (:et-state db)))))

(re-frame/reg-sub
  :et/entity
  (fn [db _]
    (:entity (:et-state db))))

(re-frame/reg-sub
  :et/annotations
  (fn [db _]
    (get-in db [:et-state :entity :annotations])))

(re-frame/reg-sub
  :et/errors
  (fn [db _]
    (:errors (:et-state db))))

(re-frame/reg-sub
  :et/new-test-from-et-url
  (fn [db _]
    (let [route "/tests/new?et_id="]
      (str "/p/" (:project-id (:et-state db)) route (get-in db [:et-state :entity :id])))))

(re-frame/reg-sub
  :et/success-message
  (fn [db _]
    (:success-message (:et-state db))))

(re-frame/reg-sub
  :et/idle-message
  (fn [db _]
    (:idle-message (:et-state db))))

(re-frame/reg-sub
  :et/report-issue-url
  (fn [db [_ annotation-position]]
    (when-let [annotation-id (get-in db [:et-state :entity :annotations annotation-position :id])]
      (if @(re-frame/subscribe [:et/integrations-enabled?])
        (str "/p/" (:project-id (:et-state db))
             "/sets/" (:testset-id (:et-state db))
             "/et/" (:entity-id (:et-state db))
             "/a/" annotation-id
             "/integration_redirector")
        (str "/p/" (:project-id (:et-state db))
             "/issues/new?from_et_id=" annotation-id)))))

(re-frame/reg-sub
  :et/integration-options
  (fn [db _]
    (:integration-options (:et-state db))))

(re-frame/reg-sub
  :et/annotation
  (fn [db [_ position]]
    (get-in db [:et-state :entity :annotations position])))

(re-frame/reg-sub
  :et/annotation-description
  (fn [db [_ position]]
    (get-in db [:et-state :entity :annotations position :description])))

(re-frame/reg-sub
  :et/integrations-enabled?
  (fn [db _]
    (:integrations (:et-state db))))

(re-frame/reg-sub
  :et/dirty-annotation?
  (fn [db [_ position]]
    (boolean (seq (get-in db [:et-state :entity :annotations position :dirty-fields])))))

(re-frame/reg-sub
  :et/annotation-id
  (fn [db [_ position]]
    (get-in db [:et-state :entity :annotations position :id])))

(re-frame/reg-sub
  :et/linking-existing
  (fn [db _]
    (:linking-existing (:et-state db))))

(re-frame/reg-sub
  :et/modal-integration-settings
  (fn [db _]
    (:modal-integration (:et-state db))))

(re-frame/reg-sub
  :et/refreshing-linked-issues?
  (fn [db [_ annotation-id]]
    (contains? (:refreshing-linked-issues (:et-state db)) annotation-id)))

(re-frame/reg-sub
  :et/nearby-tests-url
  (fn [db _]
    (get-in db [:et-state :entity :nearby-tests-url])))

(re-frame/reg-sub
  :et/run-next-test-url
  (fn [db _]
    (get-in db [:et-state :entity :run-next-test-url])))

(re-frame/reg-sub
  :et/back-to-testset-url
  (fn [db _]
    (:testset-url (:et-state db))))

(re-frame/reg-sub
  :et/annotation-types
  (fn [db _]
    (->> (:annotation-types (:et-state db))
         (map (fn [[color value]]
                {:id value :label value :color color})))))

(re-frame/reg-sub
  :et/versioning-enabled?
  (fn [db _]
    (:versioning-enabled (:et-state db))))

(re-frame/reg-sub
  :et/version-label
  (fn [db _]
    (:version-label (:et-state db))))
